import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'; 
import './Login.css'

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`https://trakersmallbusienss-3.onrender.com/api/auth/login`, {
        email,
        password,
      });

      localStorage.setItem('token', response.data.token); // ensure correct property

      Swal.fire({
        icon: 'success',
        title: 'Login Successful!',
        showConfirmButton: false,
        timer: 1500,
      });

      navigate('/dashboard');
    } catch (error) {
      console.error('Login Error:', error);
      let errorMessages =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors
          : [{ msg: 'Invalid email or password' }];

      setError(errorMessages);

      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        html: errorMessages.map((e) => `<p>${e.msg}</p>`).join(''),
        customClass: {
         confirmButton: 'my-swal-btn'
  }
      });
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 card">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Log in to your account
          </h2>
        </div>

        {/* {error.length > 0 &&
          error.map((err, index) => (
            <div key={index} className="text-red-700 dark:text-red-200">
              {err.msg}
            </div>
          ))} */}

        <form className="mt-8 space-y-6">
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field mt-1"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field mt-1"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary"
              onClick={handlesubmit}
            >
              {loading ? 'Logging in...' : 'Log in'}
            </button>
          </div>

          <div className="text-center text-sm">
            <p className="text-gray-600 dark:text-gray-400">
              Don't have an account?{' '}
              <Link to="/register" className="text-primary-600 dark:text-primary-400 hover:underline">
                Register here
              </Link><br/>
              <Link to="/Forget-Password" className="text-primary-600 dark:text-primary-400 hover:underline">
                I Forget My Password
              </Link>

            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
